import { PureComponent, type ReactNode } from "react";

import "utilities/print/Print.less";

/** Asks the browser to attempt to keep this content on one page, the browser will still add a page-break if the content is too long */
interface IPrintBreakAvoidProps {
    ["data-testid"]?: string;
    children: ReactNode;
}

export class PrintBreakAvoid extends PureComponent<IPrintBreakAvoidProps> {
    render() {
        return (
            <div className="print-break-avoid" data-testid={this.props["data-testid"]}>
                {this.props.children}
            </div>
        );
    }
}
